import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Card, Large, ContentSubtitle, SearchableSelectBox } from 'components';
import PropTypes from 'prop-types';
import { useLazyGetAnUserQuery } from 'redux/slices/definitions/userDefinitionApi';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { roleSettingsSelector } from 'redux/slices/app/authSlice';
import { permissions } from 'constant/permissions';
import { hasPermission } from 'utils/helper';

const UserOperations = ({ onNavigate }) => {
  const navigate = useNavigate();
  const [isEditOperation, setIsEditOperation] = useState(false);
  const [searchFullnameText, setSearchFullnameText] = useState('');
  const roleSettingsInfo = useSelector(roleSettingsSelector);
  const [getAnUser, anUser] = useLazyGetAnUserQuery();

  const handleOnUserSelect = (item) => {
    setSearchFullnameText(item.label);
    onNavigate('edit', item.value);
    navigate('/edit-user/' + item.value);
  };

  const showMatchedUsers = useMemo(() => {
    if (anUser.status === 'fulfilled') {
      return (
        anUser.data?.data?.map((user) => ({
          label: user.userFullName || user.fullName,
          value: user.userId || user.id,
        })) || []
      );
    }
    return [];
  }, [anUser]);

  return (
    <Card className="flex bg-white flex-col justify-center mx-auto w-full h-70vh sm:w-96 rounded-md shadow-2xl p-0 border border-default-border">
      <div className="flex flex-row w-full p-6 h-auto items-center  text-center justify-center gap-x-4">
        <Card
          className="bg-primary border-white h-32 cursor-pointer items-center justify-center text-center space-y-2"
          onClick={() => {
            hasPermission(
              permissions.userDefinition,
              'UPDATE',
              roleSettingsInfo
            ) && setIsEditOperation(true);
          }}
        >
          <i className="fa-solid fa-user-pen text-white"></i>
          <Large variant="white" weight="semibold">
            Kullanıcı Düzenle
          </Large>
        </Card>
        <Card
          className=" bg-primary border-white h-32 cursor-pointer items-center justify-center text-center space-y-2"
          onClick={() => {
            hasPermission(
              permissions.userDefinition,
              'CREATE',
              roleSettingsInfo
            ) && onNavigate('new');
          }}
        >
          <i className="fa-solid fa-user-plus text-white"></i>
          <Large variant="white" weight="semibold">
            Yeni Kullanıcı Oluştur
          </Large>
        </Card>
      </div>
      {isEditOperation && (
        <div className="px-6 pb-2 pt-0">
          <SearchableSelectBox
            inputValue={searchFullnameText}
            onChange={(text) => {
              setSearchFullnameText(text);
              if (text && text.length >= 3) {
                getAnUser({ text });
              }
            }}
            onSelect={handleOnUserSelect}
            label="Ad Soyad"
            placeholder="Ad Soyad ile arama yapabilirsiniz..."
            inputName="fullname"
            items={showMatchedUsers}
            isLoading={anUser.isFetching}
          />
        </div>
      )}
      <ContentSubtitle className="mx-auto px-6">
        {isEditOperation
          ? 'Düzenlemek istediğiniz kullanıcının adı veya soyadı ile arama yapabilirsiniz. En az 3 karakter giriniz.'
          : 'Mevcut bir kullanıcıyı düzenleyin veya yeni kullanıcı oluşturun.'}
      </ContentSubtitle>
    </Card>
  );
};

UserOperations.propTypes = {
  onNavigate: PropTypes.func,
};
export default UserOperations;
